module.exports = __webpack_public_path__ + "static/media/forwardArrowDark.74aed86c.svg";